export const REGEX_URL =
  /^(http(s)?:\/\/.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/i

export const REGEX_URL_WITHOUT_PROTOCOL = /^(?!-)[A-Za-z0-9-]+([-.]{1}[a-z0-9]+)*\.[A-Za-z]{2,6}$/i

export const REGEX_COMPANY_LATIN_NAME = /^[a-zA-Z0-9!@#$%^&()":<> ,-.№;_+=/`~'[\]]+$/

export const REGEX_CITY_NAME_FORBIDDEN_SYMBOLS = /[`~!@#$%^&*()|":<>?.№;_=/]/

export const REGEX_DIGITS_ONLY = /^\d*$/

export const REGEX_COMPANY_NAME_FORBIDDEN_SYMBOLS = /[|*?]/

export const REGEX_ADDRESS_FORBIDDEN_SYMBOLS = /[|*?]/
